import apiHelper from '../helpers/apiHelper'

export default {
  get()
  {
    return apiHelper.request('classificators')
  }
}
